<template>
  <div>
    <div>
    </div>
    <div class="d-flex justify-content-center align-items-center border border-danger">
      <iframe :src="$http.options.root + '/ppftz/pdf/ppftz' + '/' + $store.state.barpin.header.encoded_id" width="1200"
        height="800"></iframe>
    </div>
  </div>
</template>
<script>
import {ModelListSelect} from 'vue-search-select'
export default {
  components: {
    ModelListSelect
  }
}
</script>


// WEBPACK FOOTER //
// src/views/ppftz/Perekaman/Step-3.vue?4ce72cee